import { useRef } from 'react';

import { FatalAttraction as FA } from '@vpr/tracking';

import { humanize, translate } from '@vimeo/i18n-runtime';

import LiveBadge from './LiveBadge';
import styles from './PlaylistTrack.module.scss';
import TrackThumbnail from './TrackThumbnail';

const PlaylistTrack = ({
  clip,
  currentLiveViewers = 0,
  isPlaying,
  isSelected,
  isFocused,
  switchClip,
  tabIndex = -1,
}) => {
  const className = `${styles.playlistTrack} ${isSelected ? styles.selected : ''} ${
    isFocused ? styles.focused : ''
  }`;
  const trackRef = useRef(null);

  const handleClick = () => {
    // Pass offset value so when the tracklist is expanded the selected track is visible.
    const scrollOffset = trackRef.current.offsetTop - trackRef.current.clientHeight;
    switchClip(clip, isPlaying, scrollOffset);
    FA.trackClick({
      container: 'embedded_playlist',
      component: 'video',
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <li
      className={className}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      ref={trackRef}
      role="option"
      aria-selected={isSelected}
      tabIndex={tabIndex}
    >
      <TrackThumbnail isPlaying={isPlaying} isSelected={isSelected} url={clip.thumbnail} />
      <div className={styles.playlistTrackDetails}>
        <div className={styles.playlistTrackClipTitle} title={clip.title}>
          {clip.title}
        </div>
        {clip.isLive ? (
          <div className={styles.playlistTrackLiveDetails}>
            <LiveBadge />
            <span className={styles.playlistTrackLiveViewercount}>
              <svg
                className={styles.playlistTrackLiveViewerIcon}
                viewBox="0 0 20 20"
                width="10"
                height="10"
                aria-hidden="true"
              >
                <path d="M18 20H2v-4a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5zM10 10a5 5 0 1 1 5-5 5 5 0 0 1-5 5z"></path>
              </svg>
              {currentLiveViewers ? humanize(currentLiveViewers) : 0}
            </span>
          </div>
        ) : (
          <div className={styles.playlistTrackDurationPlays}>
            <span>{clip.duration}</span>
            <span aria-hidden="true">•</span>
            <span>
              {translate({
                singular: '{playCount} view',
                plural: '{playCount} views',
                count: clip.plays,
                replacements: {
                  playCount: humanize(clip.plays),
                },
              })}
            </span>
          </div>
        )}
      </div>
    </li>
  );
};

export default PlaylistTrack;
